import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import GrammarChecker from './components/GrammarChecker';
import Login from './components/Login';
import Signup from './components/Signup';
import AdminPanel from './components/AdminPanel';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="app">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route 
                path="/*" 
                element={
                  <>
                    <Header />
                    <main className="main-content">
                      <Routes>
                        <Route path="/" element={<GrammarChecker />} />
                        <Route path="/salluadmin" element={<AdminPanel />} />
                      </Routes>
                    </main>
                  </>
                }
              />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
